var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import sanitizeHtml from 'sanitize-html';
import { themeit } from 'react-themeit';

import AudioButtonController, { audioButtonControllerPropTypes, audioButtonControllerDefaultProps } from '../AudioButtonController';

import baseStyle from './styles.less';
import centeredTextStyle from './themes/centeredText.less';
import gridStyle from './themes/grid.less';
import taskQuestionStyle from './themes/taskQuestion.less';
import taskClozeStyle from './themes/taskCloze.less';
import taskAnswerStyle from './themes/taskAnswer.less';
import Tooltip from '../Tooltip';

var textWithAudioPropTypes = Object.assign({}, audioButtonControllerPropTypes, {
  text: PropTypes.string
});

var textWithAudioDefaultProps = Object.assign({}, audioButtonControllerDefaultProps, {
  text: null
});

var themeOptions = {
  base: function base(cb) {
    return cb(baseStyle);
  },
  themes: {
    centeredText: function centeredText(cb) {
      return cb(centeredTextStyle);
    },
    grid: function grid(cb) {
      return cb(gridStyle);
    },
    taskQuestion: function taskQuestion(cb) {
      return cb(taskQuestionStyle);
    },
    taskCloze: function taskCloze(cb) {
      return cb(taskClozeStyle);
    },
    taskAnswer: function taskAnswer(cb) {
      return cb(taskAnswerStyle);
    }
  }
};

var TextWithAudio = function (_Component) {
  _inherits(TextWithAudio, _Component);

  function TextWithAudio(props) {
    _classCallCheck(this, TextWithAudio);

    var _this = _possibleConstructorReturn(this, (TextWithAudio.__proto__ || Object.getPrototypeOf(TextWithAudio)).call(this, props));

    _this.setTooltip = function (e) {
      var target = e.target;

      while (!target.dataset.tooltip && target !== _this.textDiv) {
        target = target.parentNode;
      }

      if (!target.dataset.tooltip) {
        return;
      }

      var tooltipPosition = {};
      var boundingRect = target.getBoundingClientRect();
      var tooltipAboveItem = boundingRect.top > 50;

      if (!tooltipAboveItem) {
        tooltipPosition = {
          top: boundingRect.top + 26 + 13 + 'px', // 26 should be the height of a tooltip if it is one line high and that is the value we need
          left: boundingRect.left + boundingRect.width / 2 + 'px'
        };
      } else {
        tooltipPosition = {
          top: boundingRect.top - 32 - 13 + 'px', // 32 is my own height - 13 pixel for triangle and small space
          left: boundingRect.left + boundingRect.width / 2 + 'px'
        };
      }

      _this.setState({
        tooltipText: target.dataset.tooltip,
        tooltipPosition: tooltipPosition,
        tooltipAboveItem: tooltipAboveItem
      });
    };

    _this.removeTooltip = function () {
      var fixTooltip = _this.state.fixTooltip;

      if (!fixTooltip) {
        _this.setState({
          tooltipText: null,
          tooltipPosition: null
        });
      }
    };

    _this.handleMousewheel = function () {
      _this.removeTooltip();
    };

    _this.handleTouchStart = function () {
      _this.removeTooltip();
    };

    _this.handleKeyUp = function (e) {
      var fixTooltip = _this.state.fixTooltip;


      if (e.keyCode === 84) {
        _this.setState({
          fixTooltip: !fixTooltip
        });
      }
    };

    _this.renderSlideText = function () {
      var _this$props = _this.props,
          text = _this$props.text,
          allowedTags = _this$props.allowedTags,
          allowedAttributes = _this$props.allowedAttributes,
          styles = _this$props.styles;
      var _this$state = _this.state,
          tooltipPosition = _this$state.tooltipPosition,
          tooltipText = _this$state.tooltipText,
          tooltipAboveItem = _this$state.tooltipAboveItem;


      if (!text) {
        return null;
      }

      var displayText = sanitizeHtml(text, { allowedTags: allowedTags, allowedAttributes: allowedAttributes });

      return React.createElement(
        Fragment,
        null,
        React.createElement('div', {
          ref: function ref(textDiv) {
            _this.textDiv = textDiv;
          },
          className: styles.text,
          onMouseOver: _this.setTooltip,
          onMouseOut: _this.removeTooltip,
          onTouchEnd: _this.setTooltip,
          onBlur: function onBlur() {},
          onFocus: function onFocus() {},
          dangerouslySetInnerHTML: { __html: displayText }
        }),
        tooltipPosition && tooltipText ? React.createElement(Tooltip, {
          position: tooltipPosition,
          text: tooltipText,
          aboveItem: tooltipAboveItem
        }) : null
      );
    };

    _this.textDiv = null;

    _this.state = {
      tooltipPosition: null,
      tooltipText: null,
      tooltipAboveItem: true,
      fixTooltip: false
    };

    _this.handleKeyUp = _this.handleKeyUp.bind(_this);
    return _this;
  }

  _createClass(TextWithAudio, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('wheel', this.handleMousewheel);
      window.addEventListener('touchstart', this.handleTouchStart);
      window.addEventListener('keyup', this.handleKeyUp);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('wheel', this.handleMousewheel);
      window.removeEventListener('touchstart', this.handleTouchStart);
      window.removeEventListener('keyup', this.handleKeyUp);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          id = _props.id,
          text = _props.text,
          audioSource = _props.audioSource,
          autoPlay = _props.autoPlay,
          styles = _props.styles,
          className = _props.className,
          showDragIcon = _props.showDragIcon,
          showBorder = _props.showBorder,
          clicked = _props.clicked;


      var audioStyle = null;
      if (audioSource) {
        if (text) {
          audioStyle = styles.withAudio;
        } else {
          audioStyle = styles.withAudioAndNoText;
        }
      }

      return React.createElement(
        Fragment,
        null,
        React.createElement(
          'div',
          { className: styles.container + ' ' + className + ' ' + audioStyle + ' ' + (clicked && styles.clicked) + ' ' + (showBorder && styles.borderRight) },
          showDragIcon && React.createElement('div', { className: styles.dragIcon + ' icon-hamburger' }),
          this.renderSlideText(),
          audioSource && React.createElement(AudioButtonController, {
            id: id,
            className: styles.audioButton,
            audioSource: audioSource,
            autoPlay: autoPlay
          })
        )
      );
    }
  }]);

  return TextWithAudio;
}(Component);

export default themeit(themeOptions)(TextWithAudio);

TextWithAudio.propTypes = process.env.NODE_ENV !== "production" ? Object.assign({}, textWithAudioPropTypes) : {};

TextWithAudio.defaultProps = Object.assign({}, textWithAudioDefaultProps, {

  // https://www.npmjs.com/package/sanitize-html for more info
  allowedTags: ['h1', 'h2', 'h3', 'p', 'br', 'em', 'strong', 'u', 'a', 'span', 'ul', 'ol', 'li'],
  allowedAttributes: { a: ['href', 'target'], span: ['style', 'data-tooltip'], p: ['style', 'data-list'] }
});

export { textWithAudioPropTypes, textWithAudioDefaultProps };